<template>
	<div>
		<div class="content-header">
            <ol class="breadcrumb">
                <li>
                    <router-link :to="{ name: 'freightList' }">
                        物流管理
                    </router-link>
                </li>
                <li class="active">添加/更新</li>
            </ol>
        </div>
        <div class="content-from">
            <el-form ref="formName" :model="saveModel" :rules="rules" label-position="left">
                <el-form-item label="模板名称：" prop="name">
                    <el-input v-model="saveModel.name"></el-input>
                </el-form-item>
                <hr/>
                <el-button type="primary" size="small" @click="addFreightZoneClickFun">添加地区物流</el-button>
                <el-table :data="freightZones" style="width: 100%">
                    <el-table-column label="序号" type="index"/>
                    <el-table-column label="地区">
                        <template slot-scope="scope">
                            <el-select :disabled="0==scope.rowIndex?'disabled':null " v-model="scope.row.provinceZoneId">
                                <el-option v-for="item in zoneOptions" :key="item.name" :label="item.label" :value="item.name"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column label="配送起步价/￥">
                        <template slot-scope="scope">
                            <el-input-number v-model="scope.row.minFee" :min="0" :max="1000000000000"></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column label="起步价配送最大重量/KG">
                        <template slot-scope="scope">
                            <el-input-number v-model="scope.row.minFeeMaxWeight" :min="0" :max="1000000000000"></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column label="超重配送价/￥">
                        <template slot-scope="scope">
                            <el-input-number v-model="scope.row.overWeightPrice" :min="0" :max="1000000000000"></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column>
                        <template slot-scope="scope">
                            <el-button type="danger" size="mini" round @click="deleteFreightZoneFun(scope.rowIndex)" v-if="0!=scope.rowIndex">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-form-item>
                    <el-button size="small" @click="$router.back(-1)">取消</el-button>
                    <el-button type="primary" size="small" @click="saveFreightConfig()">确认</el-button>
                </el-form-item>
            </el-form>
		</div>		
	</div>
</template>
<script>
export default {
	data() {
		return { 
			zone:'',
			zoneOptions:[],
            saveModel:{},
            freightZones: [
                {    
                    provinceZoneId:'',
                    minFee:'',
                    minFeeMaxWeight:'',
                    overWeightPrice:'',
                }
            ],
            rules: {
                name: [{ required: true, message: "物流模板名称不能为空", trigger: "blur" }],
            },
		};
	},
	created(){
		var _this = this;
		_this.freightId = _this.$route.query.freightId;
		_this.detailFreight();
		_this.findZoneByLevel();
        _this.findFreightZoneConfigByFreightConfig();
	},
	methods:{
		detailFreight(){
            var _this = this;
            if (_this.freightId) {
                _this.$common.my_ajax({
                    url: 'freightConfig/detailFreightConfig',
                    data: {
                        freightId: _this.freightId
                    },
                    success: function(response) {
                        _this.saveModel = response.item;
                        
                    }
                });
            }
        },
        addFreightZoneClickFun() {
            var _this = this;
            _this.freightZones.push({
                provinceZoneId:'',
                minFee:'',
                minFeeMaxWeight:'',
                overWeightPrice:'',
            });
        },
        deleteFreightZoneFun(_index){
            var _this = this;
            _this.freightZones.splice(_index,1);
        },
        findFreightZoneConfigByFreightConfig(){
            var _this = this;
            if (_this.freightId) {
                _this.$common.my_ajax({
                    url: 'freightZoneConfig/findByFreightConfig',
                    data: {
                        freightConfigId: _this.freightId
                    },
                    success: function(response) {
                        _this.freightZones = [];
                        if(response.items){
                            response.items.forEach(item =>{
                                _this.freightZones.push({
                                    provinceZoneId:item.provinceZoneId,
                                    minFee:item.minFee,
                                    minFeeMaxWeight:item.minFeeMaxWeight,
                                    overWeightPrice:item.overWeightPrice,
                                });
                            });
                        }
                    }
                });
            }
        },
        findZoneByLevel(){
            var _this = this;
            _this.$common.my_ajax({
                url: 'zone/findZoneByLevel',
                data: {
                    level: 1
                },
                success: function(response) {
                    var _item =response.items || [];
                    var zoneList = [];
                    for(var i in _item){
                        zoneList.push({ name: _item[i].id, label: _item[i].name });
                    }
                    _this.zoneOptions = zoneList;
                }
            });
        },
        saveFreightConfig() {
            var _this = this;
            var _freightZones=_this.freightZones;
            var _zoneOptions=_this.zoneOptions;

            for (var i in _freightZones) {
                for (var j in _zoneOptions) {
                    if(_freightZones[i].provinceZoneId==_zoneOptions[j].name){
                        _freightZones[i].provinceZoneName=_zoneOptions[j].label;
                    }
                }
            }
        
            _this.saveModel.freightZones=_freightZones;
            _this.$common.my_ajax({
                url: 'freightConfig/saveFreightConfig',
                contentType: 'application/json',
                data: _this.saveModel,
                success: function(response) {
                    _this.$message({
                        type: 'success',
                        message: '保存成功'
                    });
                    _this.$router.push({ name: 'freightList' });
                }
            });
        }
	}
}
</script>
<style scoped>
#border {
    height: 110px;
    width: 1100px;
    color: silver;
    border-style: solid;
}
.title{
    font-size: 18px;
    font-weight: bold;
    border-bottom: 1px solid #cccccc;
    margin-top: 10px;
    margin-bottom: 10px;
}

.title span{
    margin-bottom: 5px;
}

th {
    background-color: #1E90FF;
    text-align: center;
    font-weight: bolder;
    color: white;
}

.tr-1 td {
    text-align: center;
    line-height: 40px !important;
}

.tr-1 td:first-child{
    font-size: 18px;
    font-weight:bold;
    color: #101010;
}

td{
    text-align:center;
}
</style>